import { Dispatch } from "redux";
import { ProductInterface } from "../models/products";
import { createActionCreator, createReducer } from "deox";
import * as braceletsService from "../services/bracelets";

export type State = {
  data: ProductInterface[] | null;
};

const defaultState: State = {
  data: null,
};

const fetchBracelets = Object.assign(
  () => async (dispatch: Dispatch) => {
    try {
      const result = await braceletsService.getAllBracelets();
      dispatch(fetchBracelets.success(result));
    } catch {
      return;
    }
  },
  {
    success: createActionCreator("@@BRACELETS/FETCH", resolve => (data: ProductInterface[]) => resolve(data)),
  }
);

const reducer = createReducer(defaultState, handleAction => [
  handleAction(fetchBracelets.success, (state, action) => ({ ...state, data: action.payload })),
]);

const actions = {
  fetchBracelets,
};

export { actions, reducer };
